import React from "react"
import { 
  VictoryChart, VictoryGroup, VictoryTooltip, VictoryLine, VictoryLegend,
  VictoryScatter, VictoryVoronoiContainer, VictoryTheme 
} from "victory"
import { groupBy } from "lodash"

const parse = (x, year) => (
  x.split(";")
    .map(line => line.split(":"))
    .map(([x, y]) => ({ x, y: parseInt(y), year }))
)

const sampleData = [
  {
    year: 2019, 
    color: "#c43a31",
    data: parse("Ene:4;Feb:3;Mar:4;Abr:3;May:12;Jun:15;Jul:35;Ago:12;Sep:0;Oct:3;Nov:12;Dic:20", 2019)
  },
  {
    year: 2020, 
    color: "#dd66ff",
    data: parse("Ene:2;Feb:2;Mar:4;Abr:7;May:6;Jun:19;Jul:20;Ago:9;Sep:3;Oct:2", 2020)
  },
]

const colors = [ "#c43a31", "#dd66ff", "#ffdd66", "#66ffdd" ]
const months = {
  "01": "Ene",
  "02": "Feb",
  "03": "Mar",
  "04": "Abr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Ago",
  "09": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dic",
}

function getChartData(firstViewDocs) {
  const lines = []
  
  // #HACK 20 hardcoded years
  for (let i = 0; i < 20; i++) {
    const year = 2019 + i
    const ys = "" + year
    const relevantDocs = firstViewDocs.filter(doc => doc.timestamp.startsWith(ys))
    if (relevantDocs.length > 0) {
      const dataD = groupBy(relevantDocs, doc => doc.timestamp.substr(5, 2))
      const data = Object.keys(dataD).sort()
        .map(key => ({ x: months[key], y: dataD[key].length, year }))
      lines.push({
        color: colors[i % colors.length],
        year,
        data
      })
    }
  }
  
  return lines
}

const MultiLineChart = ({ firstViewDocs }) => {
  const data = firstViewDocs ? getChartData(firstViewDocs) : sampleData
  console.log(data)
  return (
    <div className="graphContainer">
      <div className="legend">
        {
          data.map(line => (
            <span key={line.year} style={{ backgroundColor: line.color }}>{line.year}</span>
          ))
        }
      </div>
      <VictoryChart 
        containerComponent={
          <VictoryVoronoiContainer voronoiDimension="x" labels={(d) => `${d.year}-${d.x}: ${d.y}`} />
        }
        height={180} responsive={true}
        theme={VictoryTheme.material}
        padding={{ top: 10, bottom: 30, left: 30, right: 30 }}
      >
        {/* <VictoryLegend 
          orientation="horizontal"
          gutter={20}
          style={{ background: { fill: "black" }, title: { fontSize: 12 } }}
          data={data.map(line => ({ name: line.year, symbol: { fill: line.color }}))}
        /> */}
        {
          data.map(({ year, color, data }) => (
            <VictoryGroup key={year} color={color} data={data}>
              <VictoryLine/>
              <VictoryScatter size={(d, a) => (a ? 5 : 3)} />
            </VictoryGroup>
          ))
        }
      </VictoryChart>
    </div>  
  )
}

export default MultiLineChart